import React, {Component} from 'react';
import Button from '../button';
import DownloadIcon from '../icons/downloadIcon';
import WizardClientDetails from './wizardClientDetails';
import {getQuoteSchedule} from '../../helpers/quoteSchedule';
import _ from 'lodash';
import CenteredDots from '../General/centeredDots';
import FormResponseMessage from '../formResponseMessage';
import CustomModal from '../General/customModal';
import PopupTooltip from '../General/popupTooltip';
import InfoIcon from '../icons/infoIcon';

let pdfMake = require('pdfmake/build/pdfmake.js');
let pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class WizardStep3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copyQuoteModalOpen: false,
    };
  }

  _openCopyQuoteModal = () => {
    this.setState({
      ...this.state,
      copyQuoteModalOpen: true,
    });
  };

  _closeCopyQuoteModal = () => {
    this.setState({
      ...this.state,
      copyQuoteModalOpen: false,
    });
  };

  onEmailSend = product => {
    const pdfFile = this.getScheduleInPdf(product);
    pdfFile.getBase64(data => {
      const fileToSend = {
        encodedFile: data,
        fileType: 'application/pdf',
        name: `ARAG-QuickQuote-${this.props.quote.aragReference}-${product.masterProductName}.pdf`,
      };
      this.props.sendQuoteScheduleViaEmail({
        productId: product.masterProductId,
        quoteId: product.quoteApplicationId,
        sendBody: fileToSend,
      });
    });
  };

  onScheduleDownload = product => {
    const pdfFile = this.getScheduleInPdf(product);
    pdfFile.download(
      `ARAG-QuickQuote-${this.props.quote.aragReference}-${product.masterProductName}.pdf`,
    );
  };

  getScheduleInPdf = product => {
    const quoteAdditionalInfo = this.props._findQuoteAdditionalInfo(
      product.masterProductId,
    );
    const productInfo = this.props._getQuoteProductInfo(
      product.masterProductId,
    );
    return pdfMake.createPdf(
      getQuoteSchedule({
        ...this.props,
        productInfo: productInfo,
        quoteTitle: product.masterProductName,
        totalPremium: product.totalPremium,
        productId: product.masterProductId,
        limitOfIndemnity: product.limitOfIndemnity,
        covernote: this.props._getQuoteMessageByPosition(
          'QuickQuoteCovernoteText',
        ),
        quoteScheduleInfo: this.props._getQuoteMessageByPosition(
          'QuickQuoteScheduleInfoText',
        ),
        quoteAdditionalInfo: quoteAdditionalInfo,
      }),
    );
  };

  render() {
    const printQuoteMessage = this.props._getQuoteMessageByPosition(
      'QuickQuotePart3Print',
    );
    const emailTooltipLabel = this.props._getQuoteMessageByPosition(
      'QuickQuotePart3EmailInfo',
    );
    return (
      <div>
        <CustomModal
          isOpen={this.state.copyQuoteModalOpen}
          content={
            <div>
              <div className={'row'}>
                <div className={'col-sm-12'}>
                  Details will be copied to a new quote. Click OK to continue.
                </div>
              </div>
              <div className={'row mt-15'}>
                <div className={'col-sm-12'}>
                  <Button
                    clickHandler={() => {
                      this.props.history.push('/quote');
                      this.props.copyQuote();
                    }}
                    wrapper="btn-wrapper"
                    btnType="button"
                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                    label="OK"
                  />
                  <Button
                    clickHandler={this._closeCopyQuoteModal}
                    wrapper="btn-wrapper"
                    btnType="button"
                    btnStyle={'btn btn-primary btn-xs sharp white'}
                    label="Cancel"
                  />
                </div>
              </div>
            </div>
          }
          handleClose={this._closeCopyQuoteModal}
        />
        <WizardClientDetails {...this.props} />
        <div className="row">
          <div className="col-sm-12">
            <hr className=" applicationPolicy-hr" />
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12'}>
            <div className={'quote-wizard__quote-print-header mb-15'}>
              {printQuoteMessage.title}
            </div>
            <div
              className={'mb-15'}
              dangerouslySetInnerHTML={{__html: printQuoteMessage.body}}></div>
            <form className={'form-horizontal'}>
              {_.map(this.props.quote.chosenProducts, product => {
                const quoteAdditionalInfo = this.props._findQuoteAdditionalInfo(
                  product.masterProductId,
                );
                return (
                  <div className={'form-group'} key={product.masterProductId}>
                    <div className={'col-sm-2'}>
                      <label className="control-label.text-left formGroup-textInput-label">
                        {`${product.masterProductName}:`}
                      </label>
                    </div>
                    <div className={'col-sm-2'}>
                      <div
                        onClick={() => {
                          this.onScheduleDownload(product);
                        }}
                        className={'quote-wizard__quote-print-link'}>
                        <DownloadIcon />
                        {'Quote schedule'}
                      </div>
                    </div>
                    <div className={'col-sm-2'}>
                      <div
                        onClick={() => {
                          this.onEmailSend(product);
                        }}
                        className={'quote-wizard__quote-print-link'}>
                        <DownloadIcon />
                        {'Email'}
                      </div>
                      <div className={'pull-right'}>
                        <PopupTooltip
                          label={emailTooltipLabel.body}
                          customStyle={'quote-wizard__tooltip'}>
                          <InfoIcon variant={'small'} />
                        </PopupTooltip>
                      </div>
                    </div>
                    <div className={'col-sm-2'}>
                      <div
                        onClick={() =>
                          this.props.getQuoteProposalForms({
                            id: quoteAdditionalInfo.proposalFormId,
                          })
                        }
                        className={'quote-wizard__quote-print-link'}>
                        <DownloadIcon />
                        {'Proposal form'}
                      </div>
                    </div>
                    <div className={'col-sm-2'}>
                      <div
                        onClick={() =>
                          this.props.getQuotePolicyWordings({
                            id: quoteAdditionalInfo.policyWordingId,
                          })
                        }
                        className={'quote-wizard__quote-print-link'}>
                        <DownloadIcon />
                        {'Policy Wording'}
                      </div>
                    </div>
                    <div className={'col-sm-2'}>
                      <div
                        onClick={() =>
                          this.props.getQuotePointsOfSale({
                            id: quoteAdditionalInfo.pointOfSaleId,
                          })
                        }
                        className={'quote-wizard__quote-print-link'}>
                        <DownloadIcon />
                        {'Point of Sale'}
                      </div>
                    </div>
                  </div>
                );
              })}
            </form>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12'}>
            {/*<div className={'row'}>*/}
            {/*    <div className={'col-sm-12 quote-wizard__quote-print-header mb-15'}>*/}
            {/*        {holdCoverMessage.title}*/}
            {/*     </div>*/}
            {/*    <div*/}
            {/*        className={'col-sm-12 mb-15'}*/}
            {/*        dangerouslySetInnerHTML={{__html: holdCoverMessage.body}}*/}
            {/*    >*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<Button*/}
            {/*    clickHandler={this.props._handleQuoteCompleteSubmit}*/}
            {/*    wrapper="btn-wrapper"*/}
            {/*    btnType="button"*/}
            {/*    btnStyle={'btn btn-primary btn-xs sharp yellow'}*/}
            {/*    label="Yes"*/}
            {/*/>*/}
            <Button
              clickHandler={this._openCopyQuoteModal}
              wrapper="btn-wrapper"
              btnType="button"
              btnStyle={'btn btn-primary btn-xs sharp white'}
              label="Copy Quote"
            />
          </div>
        </div>
        {this.props.updating && (
          <div className={'col-sm-12'}>
            <CenteredDots />
          </div>
        )}
        {this.props.sendingQuoteScheduleViaEmail && (
          <div className={'col-sm-12'}>
            <CenteredDots />
          </div>
        )}
        {this.props.sendEmailSuccessResponse && (
          <div className={'row mt-15'}>
            <FormResponseMessage
              Message={this.props.sendEmailSuccessResponse}
              CenterWrapper="col-sm-12"
              MessageStyle="formResponseMessage-success"
            />
          </div>
        )}
        {this.props.sendEmailFailResponse && (
          <div className={'row mt-15'}>
            <FormResponseMessage
              Message={this.props.sendEmailFailResponse}
              CenterWrapper="col-sm-12"
              MessageStyle="formResponseMessage-reject"
            />
          </div>
        )}
        {this.props.updateErrorMessage && (
          <div className={'row mt-15'}>
            <FormResponseMessage
              Message={this.props.updateErrorMessage}
              CenterWrapper="col-sm-12"
              MessageStyle="formResponseMessage-reject"
            />
          </div>
        )}
      </div>
    );
  }
}

export default WizardStep3;
